import { BROWSER_RESULT_MAP } from 'CHECKS/browser/browserResults';
import { CAMERA_RESULT_MAP } from 'CHECKS/camera/cameraResults';
import { MICROPHONE_RESULT_MAP } from 'CHECKS/microphone/microphoneResults';
import { SPEAKERS_RESULT_MAP } from 'CHECKS/speakers/speakersResults';
import { CONNECTIVITY_RESULT_MAP } from 'CHECKS/connectivity/connectivityResults';
import browserResultTranslations from 'CHECKS/browser/browserResultTranslations.json';
import cameraResultTranslations from 'CHECKS/camera/cameraResultTranslations.json';
import microphoneResultTranslations from 'CHECKS/microphone/microphoneResultTranslations.json';
import speakersResultTranslations from 'CHECKS/speakers/speakersResultTranslations.json';
import connectivityResultTranslations from 'CHECKS/connectivity/connectivityResultTranslations.json';
import LaptopIcon from '@material-ui/icons/Laptop';
import VideocamIcon from '@material-ui/icons/Videocam';
import MicIcon from '@material-ui/icons/Mic';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';
import { BROWSER_CHECK, CAMERA_CHECK, MICROPHONE_CHECK, SPEAKERS_CHECK, CONNECTIVITY_CHECK } from 'UTILS/constants';

export const CHECK_LIST = [
  BROWSER_CHECK,
  CAMERA_CHECK,
  MICROPHONE_CHECK,
  SPEAKERS_CHECK,
  CONNECTIVITY_CHECK,
];
export const BLOCKING_CHECKS = [
  BROWSER_CHECK,
];
export const CHECK_ICON_MAP = {
  [BROWSER_CHECK]: LaptopIcon,
  [CAMERA_CHECK]: VideocamIcon,
  [MICROPHONE_CHECK]: MicIcon,
  [SPEAKERS_CHECK]: VolumeUpIcon,
  [CONNECTIVITY_CHECK]: NetworkCheckIcon,
};
export const CHECK_RESULT_MAP = {
  ...BROWSER_RESULT_MAP,
  ...CAMERA_RESULT_MAP,
  ...MICROPHONE_RESULT_MAP,
  ...SPEAKERS_RESULT_MAP,
  ...CONNECTIVITY_RESULT_MAP,
};
export const CHECK_TRANSLATION_MAP = {
  [BROWSER_CHECK]: browserResultTranslations,
  [CAMERA_CHECK]: cameraResultTranslations,
  [MICROPHONE_CHECK]: microphoneResultTranslations,
  [SPEAKERS_CHECK]: speakersResultTranslations,
  [CONNECTIVITY_CHECK]: connectivityResultTranslations,
};

export const buildCheckList = (checkToRunList) => {
  if (checkToRunList == null) {
    return CHECK_LIST;
  }
  const checkList = [BROWSER_CHECK];
  const deduplicatedCheckToRunList = [...new Set(checkToRunList)];
  const browserCheckIndex = deduplicatedCheckToRunList.indexOf(BROWSER_CHECK);
  if (browserCheckIndex === -1) {
    console.error('Self Test misuse --- Browser check is mandatory and will be included. Add it to your "checkToRunList" option.');
  } else if (browserCheckIndex !== 0) {
    console.error('Self Test misuse --- Browser check should be the first check of the list and has been moved. Re-order your "checkToRunList" option.');
  }
  deduplicatedCheckToRunList.splice(browserCheckIndex, 1);
  if (deduplicatedCheckToRunList?.length === 0) {
    return CHECK_LIST;
  }
  const validatedCheckToRunList = deduplicatedCheckToRunList.filter(checkLabel => CHECK_LIST.includes(checkLabel));
  return [...checkList, ...validatedCheckToRunList];
};
